import {
	formCatalogQuery,
	formRppCatalogQuery,
	type Forms602FormVypisKatalogDto,
	type Forms602FormKatalogDto,
} from '@gov-nx/api';
import { isArray } from '@gov-nx/core/types';
import { CatalogQueryPrefix, FormType } from './constants';

export const isFoundInCatalog = (
	formId?: string,
	data?: Forms602FormKatalogDto[]
) => isArray(data) && Boolean(data?.some((item) => item.kod === formId));

export const allFetchedAndNotFound = (
	formId: string | undefined,
	queries: Array<{ isFetched: boolean; data?: Forms602FormVypisKatalogDto }>
): boolean =>
	queries.every(
		(query) =>
			query.isFetched && !isFoundInCatalog(formId, query.data?.formulare)
	);

export const isQueryTypeRppForm = (formId?: string): boolean =>
	!!formId?.toLowerCase().startsWith(CatalogQueryPrefix.RppForm);

export const resolveFormType = (formId?: string) => {
	if (isQueryTypeRppForm(formId)) {
		return FormType.F603;
	}
	return FormType.F601;
};

export const resolveCatalogQueryFn = (formId?: string) => {
	if (isQueryTypeRppForm(formId)) {
		return formRppCatalogQuery;
	}
	return formCatalogQuery;
};
